// utils/readTime.server.ts
import { parseHTML } from 'linkedom';

type CountOptions = { wpm?: number };

const EXCLUDE_SELECTOR =
  '[data-braze-form-type], [data-partner], [data-tax-savings], [data-highlight]';

export function countWordsFromHtmlServer(
  html: string,
  options: CountOptions = {},
) {
  const wpm = options.wpm ?? 200;

  // Create a clean document and a detached container
  const { document } = parseHTML('<!doctype html><html><body></body></html>');
  const container = document.createElement('div');
  container.innerHTML = html;
  document.body.appendChild(container); // optional, but keeps querySelector/closest happy

  // Strip unwanted nodes
  container.querySelectorAll('img').forEach(el => el.remove());
  container.querySelectorAll(EXCLUDE_SELECTOR).forEach(el => el.remove());
  container
    .querySelectorAll('script, style, noscript')
    .forEach(el => el.remove());

  // Now grab text
  const text = container.textContent ?? '';

  const words = normalizeAndCount(text);
  const minutes = Math.round(words / wpm);
  const seconds = Math.round(((words % wpm) / wpm) * 60);

  return { words, minutes, seconds, wpm };
}

function normalizeAndCount(s: string) {
  const clean = s
    .replace(/\u00A0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return clean ? clean.split(' ').length : 0;
}
